<template>
  <div id="new-contract" class="box" style="padding: 20px;">
    <vue-loading :active.sync="isSaving" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>

    <transition name="fade" appear>
      <div>
        <h4>Delete {{id}} Contract</h4>
        <button class="btn btn-danger" @click="delContract()">Delete Contract</button>
      </div>
    </transition>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractDelete',
  components: {
    VueLoading
  },
  props: [
    'id'
  ],
  computed: {
    ...mapGetters([
      'contracts',
      'groups'
    ])
  },
  data () {
    return {
      isSaving: false
    }
  },
  watch: {
    id: function () {
      if (this.groups.includes(this.id)) {
        this.$router.push({ name: 'GroupDelete', params: { id: this.id } })
      } else if (!this.contracts.includes(this.id)) {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  methods: {
    delContract: function () {
      this.isSaving = true
      if (confirm('Are you sure you want to delete the contract "' + this.id + '" from the base2 portal?')) {
        HTTP.delete(`/management/contract/${this.id}`)
          .then(() => {
            this.flashMessage.success({
              message: 'Successfully deleted contract ' + this.id
            })
          })
          .catch((error) => {
            this.flashMessage.error({
              message: 'Failed to delete contract ' + error.message
            })
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    }
  }
}
</script>

<style scoped src='../assets/stylesheet/transitions.css'></style>



// WEBPACK FOOTER //
// src/views/ContractDelete.vue